import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { validateItalianFiscalCode } from "./italian-fiscal-code.validator";
import { validatePiva } from "./piva.validator";


export class FiscalIdValidations {

    static pivaFormValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if ((control.value as string)?.length == 0) return null
            return !validatePiva(control.value) ? { invalid: true } : null;
        };
    }

    static italianFiscalCodeFormValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if ((control.value as string)?.length == 0) return null
            return !validateItalianFiscalCode(control.value) ? { invalid: true } : null;
        };
    }

}

